"use client";

import { motion } from "framer-motion";
import { containerVariants } from "@/lib/animation-variants";
import MarkdownBox from "@/components/ui/markdown-box";

interface MarkdownClientProps {
  markdown: string;
}

export function DatenschutzContent({ markdown }: MarkdownClientProps) {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="mx-auto max-w-3xl">
      <MarkdownBox markdown={markdown} />
    </motion.div>
  );
}

